import _ from "lodash";
import api from "services/api";
import { toast } from "react-toastify";
import axios from "axios";

export const requestGetAccessToken = async () => {
  const req = axios.create({
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": "pt-BR",
      client_id: process.env.REACT_APP_CLIENT_ID,
      },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    "Content-Type": "application/json",
    "Accept-Language": "pt-BR",
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };

  const parameters = {
    method: "POST",
    headers: header,
  };

  const body = {
    grant_type: "client_credentials",
  };

  let access_token = "";

  access_token = localStorage.getItem("@UltragazEmpresarial:accessToken");

  if(access_token) return access_token;

  try {
    const response = await req.post("oauth/access-token", body, parameters);
    access_token = response.data.access_token;
  } catch (error) {
    const erro = error.response;

    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }

  return access_token;
};

export const validationToken = async (token, userId) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };

  const bodyToken = {
    token,
  };

  let success;

  try {
    await api.post(
      `industrial/customer/v1/users/${userId}/validations`,
      bodyToken,
      {
        headers,
      }
    );
    success = true;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação"
    );
    success = false;
  }

  return success;
};

export const sendToken = async (contact, userId, contactId = null) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };
  const bodyToken = {
    tokenType: "CHANGE_PASSWORD",
    contactId: contact?.contactId || contactId,
    url: null,
  };

  let success;

  try {
    await api.post(`industrial/customer/v1/users/${userId}/tokens`, bodyToken, {
      headers,
    });
    if (contact?.contact) {
      toast.warn(`Enviamos um código de verificação para ${contact?.contact}`);
    } else if (contactId) {
      toast.warn(`Reenviamos um código de verificação`);
    }
    success = true;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação"
    );
    success = false;
  }

  return success;
};

export const arrUniqueContactMFA = (arr) => {
  const cleaned = [];
  arr.forEach(function (itm) {
    let unique = true;
    cleaned.forEach(function (itm2) {
      if (_.isEqual(itm.contact, itm2.contact)) unique = false;
    });
    if (unique) cleaned.push(itm);
  });
  return cleaned;
};
